import { render, staticRenderFns } from "./editSample.vue?vue&type=template&id=9c0ea9b4&"
import script from "./editSample.vue?vue&type=script&lang=js&"
export * from "./editSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports